var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddressBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "address-book",
    d: "M11.679,4.375A.326.326,0,0,0,12,4.047V2.953a.326.326,0,0,0-.321-.328h-.536V1.313A1.3,1.3,0,0,0,9.857,0H1.286A1.3,1.3,0,0,0,0,1.313V12.688A1.3,1.3,0,0,0,1.286,14H9.857a1.3,1.3,0,0,0,1.286-1.312V11.375h.536A.326.326,0,0,0,12,11.047V9.953a.326.326,0,0,0-.321-.328h-.536V7.875h.536A.326.326,0,0,0,12,7.547V6.453a.326.326,0,0,0-.321-.328h-.536V4.375ZM5.571,3.5A1.75,1.75,0,1,1,3.857,5.25,1.734,1.734,0,0,1,5.571,3.5Zm3,6.475a.566.566,0,0,1-.6.525h-4.8a.566.566,0,0,1-.6-.525V9.45a1.7,1.7,0,0,1,1.8-1.575h.134a2.707,2.707,0,0,0,2.132,0h.134a1.7,1.7,0,0,1,1.8,1.575Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressBook);
export default __webpack_public_path__ + "static/media/address-book.a6e487dbebce234d6b79f42dc4f16b75.svg";
export { ForwardRef as ReactComponent };